import { useTranslation } from "react-i18next";
import { TenderDetailDrawer } from "@/pages/Tenders/TenderDetailDrawer";
import { TenderStudyModal } from "@/pages/Tenders/TenderStudyModal";
import { StudyStatusModal } from "@/pages/Studies/StudyStatusModal";
import { ModalDelete } from "@/components/ModalDelete";
import { TenderFormModal } from "@/pages/Tenders/TenderFormModal";
import { studyApi } from "@/lib/api";
import type { Tender } from "@/pages/Tenders/types";
import type { useStudies } from "@/pages/Studies/useStudies";

interface StudyDialogsProps {
    model: ReturnType<typeof useStudies>;
}
export const StudyDialogs = ({ model }: StudyDialogsProps) => {
    const { t } = useTranslation("global");
    const {
        selectedStudy,
        setSelectedStudy,
        handleOpenEdit,
        handleOpenDelete,
        handleOpenStatus,
        loadData,
        formModalOpen,
        editingStudy,
        setFormModalOpen,
        setEditingStudy,
        deleteModalOpen,
        setDeleteModalOpen,
        setDeleteTargetStudy,
        deleteTargetStudy,
        isDeleting,
        handleConfirmDelete,
        statusModalOpen,
        statusTargetStudy,
        handleCloseStatus,
        handleStatusSuccess,
        isUpdatingStatus,
        bc3ModalOpen,
        studyBc3Target,
        setBc3ModalOpen,
        setStudyBc3Target,
    } = model;
    return (
        <>
            {/* Drawers and Modals */}
            <TenderDetailDrawer
                isOpen={Boolean(selectedStudy)}
                tender={selectedStudy}
                onClose={() => setSelectedStudy(null)}
                onEdit={(std: Tender) => {
                    setSelectedStudy(null);
                    handleOpenEdit(std);
                }}
                onDelete={(std: Tender) => {
                    setSelectedStudy(null);
                    handleOpenDelete(std);
                }}
                onChangeStatus={(std: Tender) => {
                    setSelectedStudy(null);
                    handleOpenStatus(std);
                }}
                onRefresh={async (): Promise<void> => {
                    await loadData();
                    if (selectedStudy) {
                        const res = await studyApi.get(selectedStudy.id);
                        if (res?.data) {
                            setSelectedStudy(res.data);
                        }
                    }
                }}
            />

            <TenderFormModal
                isOpen={formModalOpen}
                tender={editingStudy}
                isStudy={true}
                onClose={() => {
                    setFormModalOpen(false);
                    setEditingStudy(null);
                }}
                onSuccess={async (saved: Tender) => {
                    setFormModalOpen(false);
                    setEditingStudy(null);
                    if (selectedStudy && selectedStudy.id === saved.id) {
                        setSelectedStudy(saved);
                    }
                    await loadData();
                }}
            />

            <ModalDelete
                isOpen={deleteModalOpen}
                onClose={() => {
                    setDeleteModalOpen(false);
                    setDeleteTargetStudy(null);
                }}
                description={t("studies.delete_confirm_desc")}
                itemName={
                    deleteTargetStudy?.code ||
                    deleteTargetStudy?.tender?.code ||
                    ""
                }
                itemDescription={deleteTargetStudy?.title}
                isDeleting={isDeleting}
                onConfirm={handleConfirmDelete}
                submitLabel={t("common.archive")}
            />

            <StudyStatusModal
                isOpen={statusModalOpen}
                study={statusTargetStudy}
                onClose={handleCloseStatus}
                onSubmit={handleStatusSuccess}
                isSubmitting={isUpdatingStatus}
            />

            <TenderStudyModal
                isOpen={bc3ModalOpen}
                tender={studyBc3Target}
                isApproveMode={false}
                isStudyMode={true}
                onClose={() => {
                    setBc3ModalOpen(false);
                    setStudyBc3Target(null);
                }}
                onSuccess={async () => {
                    await loadData();
                }}
            />
        </>
    );
};
